import { Svg } from 'components/svg'
import { IconTypeProps } from 'models'
import { FC } from 'react'

export const IconShare: FC<IconTypeProps & { isTextured?: boolean }> = ({
  className = '',
  isTextured,
}) => (
  <Svg className={className} fill="none" viewBox="0 0 13 15">
    <path
      d="M12.4879 6.75803C7.52273 6.44928 3.01612 3.81927 0.0764318 0.0390393C0.0275134 -0.039349 -0.0152902 0.03424 0.00458292 0.0566366L2.45509 6.78843L0.00611162 13.5618C0.00611162 13.5618 -0.00458928 13.6914 0.105477 13.5954C3.04517 9.84237 7.5426 7.13398 12.4879 6.82042C12.4879 6.82042 12.517 6.81402 12.517 6.79003C12.517 6.76603 12.4879 6.75963 12.4879 6.75963V6.75803Z"
      fill={isTextured ? 'url("#golden-texture")' : 'currentColor'}
    />
  </Svg>
)
